// src/pages/ProjectsPage.tsx
// نام فایل: ProjectsPage.tsx

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchProjects, createProject, updateProject, deleteProject } from "../api/projects";
import ProjectForm from "../components/ProjectForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPen, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../contexts/UserContext";  // اضافه شد

interface Project {
    id: number;
    title: string;
    description?: string;
    createdById: number;
}

export default function ProjectsPage() {
    const [projects, setProjects] = useState<Project[]>([]);
    const [showForm, setShowForm] = useState(false);
    const [editProjectId, setEditProjectId] = useState<number | null>(null);
    const navigate = useNavigate();

    const { user, setUser } = useUser(); // گرفتن اطلاعات کاربر از کانتکست

    const loadProjects = async () => {
        const data = await fetchProjects();
        setProjects(data);
    };

    useEffect(() => {
        loadProjects();
    }, []);

    const handleCreate = async (title: string, description?: string) => {
        const newProject = await createProject({ title, description });
        setProjects([...projects, newProject]);
        setShowForm(false);
    };

    const handleEdit = async (projectId: number, title: string, description?: string) => {
        const updatedProject = await updateProject(projectId, { title, description });
        setProjects(projects.map((p) => (p.id === projectId ? updatedProject : p)));
        setEditProjectId(null);
    };

    const handleDeleteProject = async (projectId: number) => {
        if (!window.confirm("آیا مطمئن هستید می‌خواهید این پروژه و همه تسک‌ها و نوت‌ها حذف شود؟")) return;
        await deleteProject(projectId);
        setProjects(projects.filter((p) => p.id !== projectId));
    };

    const handleLogout = () => {
        localStorage.removeItem("username");
        localStorage.removeItem("displayName");
        setUser(null);
        navigate("/");
    };

    return (
        <div style={{ marginRight: "10px", marginLeft: "10px" }}>



            {user && (
                <h2 style={{ alignContent: 'center', textAlign: 'center' }}>
                    پروژه‌های  {user.displayName} ({user.username})
                    {" "}

                </h2>
            )}

            {showForm && <ProjectForm onSubmit={handleCreate} />}

            <ul>
                {projects.map((p) => (
                    <li
                        key={p.id}
                        style={{
                            margin: "10px 0",
                            border: "1px solid var(--app-border-color)",
                            padding: "0.5rem",
                            borderRadius: 6,
                            background: "var(--app-card-bg-color)",
                            color: "var(--app-text-color)",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        {editProjectId === p.id ? (
                            <ProjectForm
                                initialTitle={p.title}
                                initialDescription={p.description}
                                onSubmit={(title, description) => handleEdit(p.id, title, description)}
                                onCancel={() => setEditProjectId(null)}
                            />
                        ) : (
                            <>
                                <span
                                    onClick={() => navigate(`/project/${p.id}`)}
                                    style={{ cursor: "pointer", fontWeight: "bold", flex: 1 }}
                                >
                                    {p.title} - {p.description}
                                </span>
                                <div style={{ display: "flex", gap: 8 }}>
                                    <button
                                        onClick={() => setEditProjectId(p.id)}
                                        title="Edit"
                                        style={{
                                            background: "none",
                                            border: "none",
                                            cursor: "pointer",
                                            fontSize: 16,
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPen} />
                                    </button>
                                    {/* دکمه حذف در صورت نیاز */}
                                    {/* <button
                    onClick={() => handleDeleteProject(p.id)}
                    title="Delete"
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    <FontAwesomeIcon icon={faTrash} />
                  </button> */}
                                </div>
                            </>
                        )}
                    </li>
                ))}
            </ul>
            <div style={{ alignContent: 'center', textAlign: 'center' }}>
                <button
                    onClick={() => {
                        setShowForm(!showForm);
                        setEditProjectId(null);
                    }}
                    style={{
                        marginBottom: "1rem", 
                        padding: "6px 10px", 
                        borderRadius: 6, fontSize: 20, 
                        background: 'var(--app-bg-color)',
                        color: 'var(--app-text-color)',
                    }}
                >
                    <FontAwesomeIcon icon={showForm ? faTimes : faPlus} />{" "}
                    {showForm ? "Cancel" : ""}
                </button>
                <button
                    onClick={handleLogout}
                    title="خروج از سیستم"
                    style={{
                        position: "absolute",
                        background: 'var(--app-text-color)',
                        color: 'var(--app-bg-color)',
                        border: "1px solid var(--app-border-color)",
                        borderRadius: 6,
                        padding: "6px 10px",
                        cursor: "pointer",
                        fontSize: 16,
                        left: 25
                    }}
                >خروج</button>
                
            </div>
        </div>
    );
}
